/* ============================================
   GIGLIOTTO TENUTE — Hero Carousel
   Only loaded on pages with hero.liquid
   ============================================ */

if (window.__heroCarouselInit) { /* guard: section rendered multiple times */ } else {
  window.__heroCarouselInit = true;

  (function initHeroCarousel() {
    const carousel = document.getElementById('hero-carousel');
    if (!carousel) return;

    const slides = carousel.querySelectorAll('.hero__slide');
    const dots   = document.querySelectorAll('#hero-carousel-dots .hero__dot');
    if (slides.length <= 1) return;

    const speed = parseInt(carousel.dataset.autoplay, 10) || 5000;
    let current = 0;
    let timer   = null;

    function goTo(index) {
      slides[current].classList.remove('active');
      dots[current]?.classList.remove('active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('active');
      dots[current]?.classList.add('active');
    }

    function start() { timer = setInterval(() => goTo(current + 1), speed); }
    function stop()  { clearInterval(timer); }

    dots.forEach((dot, i) => dot.addEventListener('click', () => { stop(); goTo(i); start(); }));
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);

    start();
  })();
}
